module.exports = __webpack_public_path__ + "static/media/rules-puzzle-empty.8b828995.png";